import { useState } from 'react'
import { X } from '@phosphor-icons/react'
import { Button } from './ui/button'
import { RatingInput } from './RatingStars'
import { submitOrderReview } from '../services/reviews'

interface ReviewFormProps {
  orderId: string
  freightForwarderName?: string
  initialRating?: number
  initialComment?: string
  onClose: () => void
  onSubmitted: () => void
}

export function ReviewForm({ orderId, freightForwarderName, initialRating = 0, initialComment = '', onClose, onSubmitted }: ReviewFormProps) {
  const [rating, setRating] = useState(initialRating)
  const [comment, setComment] = useState(initialComment)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (rating < 1) {
      setError('Selecione uma nota de 1 a 5 estrelas')
      return
    }
    setError(null)
    setSubmitting(true)
    try {
      await submitOrderReview(orderId, rating, comment.trim() || undefined)
      onSubmitted()
    } catch (err: any) {
      setError(err.response?.data?.error || 'Falha ao enviar avaliação')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold">Avaliar agente de carga</h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          {freightForwarderName && (
            <p className="text-sm text-gray-600">
              Como foi sua experiência com <strong>{freightForwarderName}</strong>?
            </p>
          )}
          <div className="text-center py-2">
            <RatingInput value={rating} onChange={setRating} size={36} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Comentário (opcional)
            </label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={4}
              maxLength={1000}
              placeholder="Conte como foi a experiência: pontualidade, comunicação, atendimento..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
            <p className="text-xs text-gray-400 mt-1">{comment.length}/1000</p>
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={onClose} disabled={submitting}>
              Cancelar
            </Button>
            <Button type="submit" disabled={submitting || rating < 1}>
              {submitting ? 'Enviando...' : 'Enviar avaliação'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
